import { render, staticRenderFns } from "./life.vue?vue&type=template&id=8c339cf4&scoped=true&"
import script from "./life.vue?vue&type=script&lang=js&"
export * from "./life.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c339cf4",
  null
  
)

export default component.exports